import { NominationScrubbingStatus } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardNominationScrubbingStatus: (
  fetchContext: FetchContext,
  awardId: number,
  nominationId: number,
  accessToken?: string,
) => Promise<NominationScrubbingStatus> = (fetchContext, awardId, nominationId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/nominations/${nominationId}/scrubbing-status`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NominationScrubbingStatus>(fetchContext.errorStore, response, 'get award nomination scrubbing status'));
